import React, { useCallback } from "react"
import clsx from "clsx"
import styles from "./index.module.scss"

export interface TopLayerProps {
  active?: boolean
  className?: string
  style?: React.CSSProperties
  onDropEnd?: () => void
}

/**
 * 卷帘遮罩（从 Loading 提取）
 * - 非激活：保持 Loading 中 .topLayer 的默认样式
 * - 激活：应用 translate3d(0, 100vh, 0) 盖满视口（横屏时为 100vw）
 */
export const TopLayer: React.FC<TopLayerProps> = ({
  active = false,
  className,
  style,
  onDropEnd,
}) => {
  const handleTransitionEnd = useCallback(
    (e: React.TransitionEvent<HTMLDivElement>) => {
      if (e.propertyName !== "transform") return
      if (active) {
        onDropEnd?.()
      }
    },
    [active, onDropEnd]
  )

  return (
    <div
      className={clsx(styles.topLayer, active && styles.active, className)}
      style={style}
      onTransitionEnd={handleTransitionEnd}
    />
  )
}

export default TopLayer

